import { Metadata } from '@/app/types/metadata';
import { ApiClient } from './client';

export class MetadataClient extends ApiClient {
  getAll = async () => {
    return this._get<Metadata>('metadata/');
  };
}
